// extracted by mini-css-extract-plugin
export default {"Item":"Item_nHT7w","description":"description_0xoD9","commerceId":"commerceId_M6kSs","price":"price_7k4fc","status":"status_eyXKP","updatedAt":"updatedAt_s3C1N"};